// ============================================================
// Wallet detection — works with Trust Wallet, MetaMask, Binance,
// SafePal, TokenPocket, Coinbase, and any injected EIP-1193 wallet.
// ============================================================

export function detectWallet() {
  if (typeof window === "undefined") return null;
  const eth = window.ethereum;
  if (!eth) return null;

  if (eth.isTrust || eth.isTrustWallet) return "TrustWallet";
  if (eth.isMetaMask && !eth.isBraveWallet) return "MetaMask";
  if (eth.isBinance) return "Binance";
  if (eth.isSafePal) return "SafePal";
  if (eth.isTokenPocket) return "TokenPocket";
  if (eth.isCoinbaseWallet) return "Coinbase";
  if (eth.isBraveWallet) return "Brave";
  if (eth.isOKExWallet || eth.isOkxWallet) return "OKX";
  if (eth.isImToken) return "imToken";
  if (eth.isMathWallet) return "MathWallet";
  return "Wallet";
}

export function hasInjectedWallet() {
  return typeof window !== "undefined" && !!window.ethereum;
}

// Returns the primary provider. Trust Wallet and some multi-wallet browsers
// expose window.ethereum.providers; pick the connected one preferentially.
export function getInjectedProvider() {
  if (typeof window === "undefined") return null;
  const eth = window.ethereum;
  if (!eth) return null;

  // Multi-provider environment (e.g., MetaMask + Coinbase both installed)
  if (Array.isArray(eth.providers) && eth.providers.length > 0) {
    // Prefer Trust Wallet if present
    const trust = eth.providers.find((p) => p.isTrust || p.isTrustWallet);
    if (trust) return trust;
    const metamask = eth.providers.find((p) => p.isMetaMask && !p.isBraveWallet);
    if (metamask) return metamask;
    return eth.providers[0];
  }
  return eth;
}

// Deep link helpers for opening the site inside Trust Wallet browser
export function isMobile() {
  if (typeof navigator === "undefined") return false;
  return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
}

export function openInTrustWallet() {
  if (typeof window === "undefined") return;
  const url = window.location.href;
  const encoded = encodeURIComponent(url);
  window.location.href = `https://link.trustwallet.com/open_url?coin_id=20000714&url=${encoded}`;
}
